import { ClassesBuilder } from '@utilities';

const classesConfig = {
  link: 'font-bold whitespace-nowrap',
};

export default new ClassesBuilder(classesConfig);
